import { Inject, Injectable } from '@angular/core';
import { DevwareMetaData, DwAppPermissionEntity, DwAppPermissionMetaData, DwAttributeType, DwCacheService, DwContextDefinition, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwQueryHelper, DwQueryMdAttribute, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, AppMetaDataLookups, FlightSchoolEntity } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { SchoolRepositoryService } from '../services/school-repository.service';
import { SUBSCRIPTION_CHANGED_TOPC } from '../../payments/services/payments-repository.service';


export const SchoolFeatureContext = 'SchoolFeatureContext';
@DwCustomContextDefinition({
    keyName: SchoolFeatureContext,
    display: 'School Features',
    isGlobal: true,
})
@Injectable()
export class SchoolFeatureContextService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private schoolRepositoryService: SchoolRepositoryService
        ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (context) => this.getCustomContext(context);
        //contextDef.loadContext = (context) => this.getCustomContext(context);

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];

        contextDef.cacheInvalidationTopics.push(SUBSCRIPTION_CHANGED_TOPC);
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Subscription));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchool));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchoolCourse));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchoolPackage));
        
        contextDef.data = {}; // Show that data is loaded so it will call getCustomContextFunction

        contextDef.attributes = [];
        contextDef.noCache = true;

        this.addProperty(contextDef.attributes, "FlightSchoolId", "Flight School id", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "FlightSchoolName", "Flight School Name", DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(contextDef.attributes, "FlightSchoolUrl", "Flight School Url", DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(contextDef.attributes, "FlightSchoolRegistrationUrl", "Registration Link", DwAttributeType.Text, DwControlType.Textbox);

        this.addProperty(contextDef.attributes, "SubscriptionTierId", "Subscription Tier Id", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "SubscriptionTierName", "Subscription Tier Name", DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(contextDef.attributes, "IsMarketplaceEnabled", "Is Marketplace Enabled", DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(contextDef.attributes, "CourseCount", "Course Count", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "PackageCount", "Package Count", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "Features", "Features", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.SubscriptionFeatureAllItems);

        this.addProperty(contextDef.attributes, "HasDefaultPaymentMethod", "Has Default Payment", DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(contextDef.attributes, "FlightSchoolCreatedDateTime", "Flight School Created", DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(contextDef.attributes, "FlightSchoolModifiedDateTime", "Flight School MOdified", DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(contextDef.attributes, "FlightSchoolThemeId", "Flight School Theme", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "ProcessorConfigId", "Processor Config Id", DwAttributeType.Integer, DwControlType.NumericTextBox);
    }

    getCustomContext(context: any): any {
        return this.schoolRepositoryService.getSchoolFeatures()
            .pipe(tap(features => {
               // console.log("SchoolFeatureContext.getCustomContext", features);
            }));
    }
}
